// LICENSE : MIT
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Dispatcher_1 = require("./Dispatcher");
var UseCaseIdGenerator_1 = require("./UseCaseIdGenerator");
var DispatcherPayloadMeta_1 = require("./DispatcherPayloadMeta");
var ErrorPayload_1 = require("./payload/ErrorPayload");
var assert_1 = require("./util/assert");
exports.defaultUseCaseName = "<Functiona-UseCase>";
var getFunctionalExecute = function (functionalUseCase, context) {
    try {
        var execute = functionalUseCase(context);
        if (process.env.NODE_ENV !== "production") {
            assert_1.assertOK(typeof execute === "function", "Functional UseCase should return a executor function.");
        }
        return execute;
    }
    catch (error) {
        if (process.env.NODE_ENV !== "production") {
            console.error("Warning(UseCase): This is wrong Functional UseCase.\nExample:\n    \n    const useCase = ({ dispatcher }) => {\n        return (args) => {\n            // execute\n        }\n    };\n    \n    context.useCase(useCase).execute(\"args\");\n");
        }
        throw error;
    }
};
/**
 * Functional version of UseCase class.
 * The user pass a function as UseCase
 * @example
 *
 * const functionalUseCase = ({ dispatcher }) => {
 *   return (...args) => {
 *      dispatcher.dispatch({ type: "fire" });
 *   }
 * }
 *
 */
var FunctionalUseCase = /** @class */ (function (_super) {
    __extends(FunctionalUseCase, _super);
    function FunctionalUseCase(functionUseCase) {
        var _this = _super.call(this) || this;
        var dispatcher = {
            dispatch: function (payload) {
                // system dispatch has meta
                // But, when meta is empty, the `payload` object generated by user
                var useCaseMeta = new DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl({
                    // this dispatch payload generated by this UseCase
                    useCase: _this,
                    // parent is the same with UseCase. because this useCase dispatch the payload
                    parentUseCase: null,
                    // the user create this payload
                    isTrusted: false,
                    // Always false because the payload is dispatched from this working useCase.
                    isUseCaseFinished: false
                });
                _this.dispatch(payload, useCaseMeta);
            }
        };
        var context = {
            dispatcher: dispatcher
        };
        /*
            const functionalUseCase = ({ dispatcher }) => {
                return (...args) => { } // <= executor
            }
         */
        _this.executor = getFunctionalExecute(functionUseCase, context);
        _this.id = UseCaseIdGenerator_1.generateNewId();
        _this.name = functionUseCase.displayName || functionUseCase.name || exports.defaultUseCaseName;
        return _this;
    }
    /**
     * execute functional UseCase
     */
    FunctionalUseCase.prototype.execute = function () {
        var _ = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _[_i] = arguments[_i];
        }
        return this.executor.apply(this, _);
    };
    /**
     * implementation throwError
     * @param error
     */
    FunctionalUseCase.prototype.throwError = function (error) {
        var meta = new DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl({
            useCase: this,
            isTrusted: true,
            isUseCaseFinished: false
        });
        var payload = new ErrorPayload_1.ErrorPayload({
            error: error
        });
        this.dispatch(payload, meta);
    };
    return FunctionalUseCase;
}(Dispatcher_1.Dispatcher));
exports.FunctionalUseCase = FunctionalUseCase;
//# sourceMappingURL=FunctionalUseCase.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/FunctionalUseCase.js
// module id = 477
// module chunks = 0